import React from "react";

const Behance = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 504.4 504.4"
    >
      <g>
        <g>
          <path id="hover" fill="#fff" d="M195.2,184.2H188h-48v44h51.6c9.2,0,17.2-2.4,17.2-23.6C208.8,183.4,195.2,184.2,195.2,184.2z" />
        </g>
      </g>
      <g>
        <g>
          <path id="hover" fill="#fff" d="M195.2,260.2H140v56h48.4c0.8,0,2,0,3.6,0c8,0,23.2-3.2,23.2-27.2C215.6,260.6,195.2,260.2,195.2,260.2z" />
        </g>
      </g>
      <g>
        <g>
          <path
          fill="#fff"
          id="hover"
            d="M377.6,0.2H126.4C56.8,0.2,0,57,0,126.6v251.6c0,69.2,56.8,126,126.4,126H378c69.6,0,126.4-56.8,126.4-126.4V126.6
			C504,57,447.2,0.2,377.6,0.2z M296,160.2h84v20h-84V160.2z M256.8,291.8c0,62.4-61.6,64.4-61.6,64.4h-56.8h-1.6H96v-208h40.4h1.6
			h56.8c30.8,0,55.2,17.6,55.2,54.4c0,36.8-29.6,38.8-29.6,38.8C259.6,241,256.8,291.8,256.8,291.8z M407.6,288.2H306.4
			c0,40,34.4,36.8,34.4,36.8c32.4,0,31.2-20.8,31.2-20.8h34.4c0,56-66.8,53.6-66.8,53.6c-80,0-74.8-78.8-74.8-78.8s0-79.2,74.8-79.2
			C418.4,199.4,407.6,288.2,407.6,288.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path id="hover" fill="#fff" d="M340.4,228.6c-30,0-34.4,31.6-34.4,31.6h64C370,260.2,370.4,228.6,340.4,228.6z" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default Behance;
